/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

export const experimentsListWidgetConfigLimitDefault = 10
export const experimentsListWidgetConfigLimitMax = 25

export const experimentsListWidgetConfigOrderByDefault = `created_at`
export const experimentsListWidgetConfigOrderDirectionDefault = `DESC`
export const experimentsListWidgetConfigStatusDefault = `all`

export const ExperimentsListWidgetConfig = /* @__PURE__ */ zod.object({
    limit: zod
        .number()
        .min(1)
        .max(experimentsListWidgetConfigLimitMax)
        .default(experimentsListWidgetConfigLimitDefault)
        .describe('Maximum number of experiments to return.'),
    orderBy: zod
        .enum(['created_at', 'name', 'start_date'])
        .default(experimentsListWidgetConfigOrderByDefault)
        .describe('Experiment list sort column.'),
    orderDirection: zod
        .enum(['ASC', 'DESC'])
        .default(experimentsListWidgetConfigOrderDirectionDefault)
        .describe('Sort direction for orderBy.'),
    status: zod
        .enum(['draft', 'running', 'paused', 'exposure_frozen', 'stopped', 'all'])
        .default(experimentsListWidgetConfigStatusDefault)
        .describe('Experiment status filter.'),
    createdBy: zod
        .union([zod.number(), zod.null()])
        .optional()
        .describe('Filter by creator (user id). Omit for any creator.'),
})

export type ExperimentsListWidgetConfig = zod.input<typeof ExperimentsListWidgetConfig>
export type ExperimentsListWidgetConfigOutput = zod.output<typeof ExperimentsListWidgetConfig>
